import { Stack } from '@ltvco/refresh-lib/theme';

import { MenuItem } from './MenuItem';

type UpgradeSectionProps = {
  onUpgradeClick: () => void;
  onLearnMoreClick?: () => void;
};

export const UpgradeSection = ({
  onUpgradeClick,
  onLearnMoreClick,
}: UpgradeSectionProps) => {
  return (
    <Stack sx={{ py: 1 }}>
      <MenuItem label="Upgrade" onClick={onUpgradeClick} />
      <MenuItem label="Learn More" onClick={onLearnMoreClick || (() => {})} />
    </Stack>
  );
};
